/* import __COLOCATED_TEMPLATE__ from './trigger-phone-reusable-workflow-component.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type TriggerPhoneReusableWorkflow from 'embercom/models/operator/visual-builder/step/trigger-phone-reusable-workflow';

export interface Arguments {
  step: TriggerPhoneReusableWorkflow;
  readOnly: boolean;
  editorState: $TSFixMe;
}

export default class TriggerPhoneReusableWorkflowComponent extends Component<Arguments> {
  get isValid() {
    return this.args.step.validations.isValid;
  }

  @action
  setSelectedWorkflow(workflow: $TSFixMe) {
    this.args.step.triggerableWorkflowId = workflow?.value;
    this.args.step.compatibleChannels = workflow?.compatibleChannels;
    this.args.step.userVisible = workflow?.userVisible;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::TriggerPhoneReusableWorkflowComponent': typeof TriggerPhoneReusableWorkflowComponent;
    'workflows/graph-editor/node-items/steps/TriggerPhoneReusableWorkflowComponent': typeof TriggerPhoneReusableWorkflowComponent;
  }
}
